export var Types = {
  Dark: 'OVERLAY/DARK',
  Light: 'OVERLAY/LIGHT',
  Loading: 'OVERLAY/LOADING',
  Transparent: 'OVERLAY/Transparent'
};
export var SHARED_Z_INDEX = 0;